import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const location = useLocation();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated) {
    // If the path is a meeting view, store it for redirection after login
    if (location.pathname.startsWith('/view/')) {
      return <Navigate to={`/login?meetingUrl=${encodeURIComponent(location.pathname)}`} />;
    }
    return <Navigate to="/login" />;
  }
  
  return children;
};

export default PrivateRoute;